const SEARCH_ADMIN = 'SEARCH_ADMIN';
const SEARCH_PUBLISHED = 'SEARCH_PUBLISHED';
const SEARCH_RESULTS_OVER_SCAN_BUFFER = 0;
const SEARCH_RESULTS_ELEMETS_HEIGHT_ABOVE_LIST = 186;
const SEARCH_RESULTS_ITEM_SIZE = 105;
const DEFAULT_RESULTS_KEYS = 'name, url';
const SEARCH_BUTTON = 'search-button';
const FILE = 'file';

export {
  SEARCH_ADMIN,
  SEARCH_PUBLISHED,
  SEARCH_RESULTS_OVER_SCAN_BUFFER,
  SEARCH_RESULTS_ELEMETS_HEIGHT_ABOVE_LIST,
  SEARCH_RESULTS_ITEM_SIZE,
  DEFAULT_RESULTS_KEYS,
  SEARCH_BUTTON,
  FILE
};
